import { render, staticRenderFns } from "./BountyHeadshot.vue?vue&type=template&id=38b5e642&scoped=true"
import script from "./BountyHeadshot.vue?vue&type=script&lang=js"
export * from "./BountyHeadshot.vue?vue&type=script&lang=js"
import style0 from "./BountyHeadshot.vue?vue&type=style&index=0&id=38b5e642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5e642",
  null
  
)

export default component.exports